import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { API_URL_COMPANIES } from '../../services/basic.service';
import { AgentShortcut } from './agent-shortcut.model';

@Injectable({
  providedIn: 'root',
})
export class AgentShortcutService {
  constructor(private httpClient: HttpClient) {}

  getAgentShortcuts(companyId: number, siteId: number): Observable<AgentShortcut[]> {
    return this.httpClient
      .get<AgentShortcut[]>(`${API_URL_COMPANIES}/${companyId}/sites/${siteId}/agent-scenario-shortcuts`)
      .pipe(
        catchError(() => of({ shortcuts: [] })),
        map((result: any) => result?.shortcuts)
      );
  }
}
